module.exports = __webpack_public_path__ + "images/TLC_2025_Radiant_lilac_mobile-3x.5e0d8d8606ac2d86416963c37ca44611.png";